import React, { useState } from "react";
import TextAreaNew from "./TextAreaNew";

/**
 * Example usage of TextAreaNew component showing how to use it
 * with Tailwind classes for customization
 */
const TextAreaNewExample: React.FC = () => {
	const [basicText, setBasicText] = useState("");
	const [descriptionText, setDescriptionText] = useState(
		"This is a sample description for a product or service."
	);
	const [feedbackText, setFeedbackText] = useState("");
	const [commentText, setCommentText] = useState("");

	const handleAiGenerate = () => {
		setDescriptionText(
			"AI generated content: This is an automatically generated description that provides comprehensive details about the subject matter."
		);
	};

	return (
		<div className="p-6 max-w-2xl mx-auto space-y-6">
			<h2 className="text-2xl font-bold mb-6">TextAreaNew Examples</h2>

			{/* Basic textarea */}
			<TextAreaNew
				label="Basic Text Area"
				value={basicText}
				onChangeText={setBasicText}
				placeholder="Enter your text here..."
				description="This is a basic textarea example"
			/>

			{/* Textarea with icon */}
			<TextAreaNew
				label="Feedback"
				icon="email"
				value={feedbackText}
				onChangeText={setFeedbackText}
				placeholder="Please provide your feedback..."
				mandatory
				rows={3}
			/>

			{/* Textarea with AI generate button */}
			<TextAreaNew
				label="Product Description"
				value={descriptionText}
				onChangeText={setDescriptionText}
				placeholder="Describe your product..."
				rows={5}
				aiGenerateButton={{
					onClickAiGenerateButton: handleAiGenerate,
					aiGenerateButtonText: "Generate with AI",
					disabledAiGenerateButton: false,
					loadingAiGenerateButton: false,
					tooltipText: "Click to generate content using AI",
				}}
			/>

			{/* Custom styled textarea */}
			<TextAreaNew
				label="Custom Styled Comments"
				value={commentText}
				onChangeText={setCommentText}
				placeholder="Add your comments..."
				rows={4}
				containerClassName="mb-8"
				wrapperClassName="bg-gray-50 border-gray-400 rounded-lg shadow-sm focus-within:shadow-md focus-within:border-purple-500"
				textareaClassName="text-lg text-purple-700 placeholder-purple-400"
			/>

			{/* Disabled textarea */}
			<TextAreaNew
				label="Disabled Text Area"
				value="This textarea is disabled and cannot be edited"
				disabled
				description="This textarea is disabled for demonstration purposes"
				rows={2}
			/>

			{/* Invalid textarea */}
			<TextAreaNew
				label="Invalid Text Area"
				value="This content has validation errors"
				isValid={false}
				errors="Please provide valid content"
				rows={2}
			/>

			{/* Textarea with custom height */}
			<TextAreaNew
				label="Large Text Area"
				value={basicText}
				onChangeText={setBasicText}
				placeholder="This is a larger textarea..."
				height="200px"
				resize="both"
				description="This textarea can be resized both horizontally and vertically"
			/>

			{/* Read-only textarea */}
			<TextAreaNew
				label="Read-only Content"
				value="This is read-only content that cannot be modified by the user. It's useful for displaying information that should not be editable."
				readOnly
				rows={3}
				wrapperClassName="bg-gray-100"
			/>

			{/* Textarea with no resize */}
			<TextAreaNew
				label="Fixed Size Text Area"
				value={commentText}
				onChangeText={setCommentText}
				placeholder="This textarea cannot be resized..."
				rows={3}
				resize="none"
				description="This textarea has resize disabled"
			/>
		</div>
	);
};

export default TextAreaNewExample;
